function svgNodeToString(svg) {
  if (!svg.getAttribute("xmlns")) {
    svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  }
  return new XMLSerializer().serializeToString(svg);
}

function svgStringToDataUrl(svgString) {
  const encoded = encodeURIComponent(svgString).replace(/'/g, "%27").replace(/"/g, "%22");
  return `data:image/svg+xml;charset=utf-8,${encoded}`;
}

async function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = (e) => reject(e);
    img.src = src;
  });
}

/**
 * SVG -> PNG Blob.
 * Рекомендація: outSize=41, scale=4 (рендер 164x164 і даунскейл).
 */
export async function exportAvatarPngBlob(
  svgEl,
  options = {}
) {
  const outSize = options.outSize ?? 41;
  const scale = options.scale ?? 4;
  const background = options.background;

  const svgString = svgNodeToString(svgEl);
  const dataUrl = svgStringToDataUrl(svgString);
  const img = await loadImage(dataUrl);

  const bigSize = outSize * scale;
  const bigCanvas = document.createElement("canvas");
  bigCanvas.width = bigSize;
  bigCanvas.height = bigSize;
  const bigCtx = bigCanvas.getContext("2d");
  if (!bigCtx) throw new Error("Canvas 2D context is not available");

  bigCtx.imageSmoothingEnabled = true;
  bigCtx.imageSmoothingQuality = "high";
  bigCtx.clearRect(0, 0, bigSize, bigSize);
  if (background) {
    bigCtx.fillStyle = background;
    bigCtx.fillRect(0, 0, bigSize, bigSize);
  }
  bigCtx.drawImage(img, 0, 0, bigSize, bigSize);

  const outCanvas = document.createElement("canvas");
  outCanvas.width = outSize;
  outCanvas.height = outSize;
  const outCtx = outCanvas.getContext("2d");
  if (!outCtx) throw new Error("Canvas 2D context is not available");

  outCtx.imageSmoothingEnabled = true;
  outCtx.imageSmoothingQuality = "high";
  outCtx.clearRect(0, 0, outSize, outSize);
  if (background) {
    outCtx.fillStyle = background;
    outCtx.fillRect(0, 0, outSize, outSize);
  }
  outCtx.drawImage(bigCanvas, 0, 0, outSize, outSize);

  const blob = await new Promise((resolve, reject) => {
    outCanvas.toBlob((b) => (b ? resolve(b) : reject(new Error("PNG blob export failed"))), "image/png");
  });

  return blob;
}

export async function exportAvatarPngDownload(
  svgEl,
  filename = "avatar.png",
  options = {}
) {
  const blob = await exportAvatarPngBlob(svgEl, options);
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();

  URL.revokeObjectURL(url);
}
